import { render, staticRenderFns } from "./DeviceRomDownload.vue?vue&type=template&id=33ab8be8&scoped=true"
import script from "./DeviceRomDownload.vue?vue&type=script&lang=js"
export * from "./DeviceRomDownload.vue?vue&type=script&lang=js"
import style0 from "./DeviceRomDownload.vue?vue&type=style&index=0&id=33ab8be8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ab8be8",
  null
  
)

export default component.exports